export default {
  isLoading: false,
  allConfigs: {},
  projectId: null,
  highlightOverdue: false,
  allFields: [],
  contextMenus: [],
  nameEditTaskKey: null,
  taskCardEditing: null,
  taskSettingsInfo: null,
  newTasksPool: [],
  customSort: [],
  datesWidth: 180
}
